"use client"

import { ColumnDef } from "@tanstack/react-table"
import { DataTableColumnHeader } from "../ui/datatable/datatablecolumnheader"
import { K8sPodDetails } from "../K8sInfo/model"
import { Link } from "react-router-dom"

export const columns: ColumnDef<K8sPodDetails>[] = [
    {
        id: "environment",
        accessorKey: "environment",
        header: ({ column }) => (
            <DataTableColumnHeader column={column} title="Environment" />
        ),
        cell: ({ row }) => (
            <div>
                {row.getValue("environment")}
            </div>
        ),
        filterFn: (row, id, value) => {
            return value.includes(row.getValue(id))
        },
    },
    {
        id: "nodeName",
        accessorKey: "nodeName",
        header: ({ column }) => (
            <DataTableColumnHeader column={column} title="Node" />
        ),
        cell: ({ row }) => (
            <div className="font-semibold">
                {row.getValue("nodeName") !== "" ? row.getValue("nodeName") : "n/a"}
            </div>
        ),
    },
    {
        id: "name",
        accessorKey: "name",
        header: ({ column }) => (
            <DataTableColumnHeader column={column} title="Pod Name" />
        ),
        cell: ({ row }) => (
            <div className="font-medium whitespace-nowrap text-ellipsis">
                <Link 
                    className={"p-2 bg-primarytransparent border border-primary text-textlight"}
                    to={`/service?service=/k8s/metoro/metoro-node-agent&tab=k8s`}
                >
                    {row.getValue("name")}
                </Link>
            </div>
        ),
    },
    {
        id: "status",
        accessorKey: "status",
        header: ({ column }) => (
            <DataTableColumnHeader column={column} title="Status" />
        ),
        cell: ({ row }) => (
            <div>
                {row.getValue("status")}
            </div>
        ),
        filterFn: (row, id, value) => {
            return value.includes(row.getValue(id))
        },
    },
    {
        id: "message",
        accessorKey: "message",
        header: ({ column }) => (
            <DataTableColumnHeader column={column} title="Kubernetes Scheduling Information" />
        ),
        cell: ({ row }) => (
            <div className="text-right">
                {row.getValue("message")}
            </div>
        ),
    },
]

export const filters = [
    {
        filteringColumn: "environment",
        title: "Environment"
    },
    {
        filteringColumn: "status",
        title: "Status"
    }
]
